<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="contract">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            合同管理
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row style="float: left;">
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">合同上传</el-button>
                    <el-button type="danger" :disabled='disabledLook' @click="lookContract">合同查看</el-button>
                    <el-button type="danger" :disabled='disabledCancellation' @click="cancellation">作废</el-button>
                </el-row>
                <div style="float:right">
                    <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="margin:0 5px;width:200px"></el-input>
                    <el-select
                        v-model="uploadContractClassCode" clearable 
                            style="margin:0 5px;width:200px"
                        placeholder="请选择合同分类">
                        <el-option
                            v-for="item in uploadContractClassValue"
                            :key="item.uploadContractClassCode"
                            :label="item.name"
                            :value="item.uploadContractClassCode">
                        </el-option>
                    </el-select>
                    <el-select
                        v-model="status"  style="margin:0 5px;width:200px" placeholder="请选择合同状态">
                        <el-option
                            v-for="item in statusValue"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                </div>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>


            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>

                        <el-table-column prop="uploadContractClass.name" label="合同分类"></el-table-column>

                        <el-table-column prop="createTime" :formatter="formatterTime" label="上传时间"></el-table-column>

                        <el-table-column prop="status"  label="合同状态">
                            <template slot-scope="scope">
                                <el-tag type="success"  v-show="scope.row.status==0" effect="plain">正常</el-tag>
                                <el-popover
                                    placement='right'
                                    title="作废原因"
                                    width="200"
                                    trigger="hover"
                                    :content="scope.row.cancellation">
                                    <el-tag type="danger"  slot="reference"  v-show="scope.row.status==1" effect="plain">作废</el-tag>
                                </el-popover>
                            </template>
                        </el-table-column>
                        
                        <el-table-column prop="remarks" show-overflow-tooltip label="备注"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                        </div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>
            <el-dialog :visible.sync="dialogVisible" top='30vh' :modal-append-to-body='false'>
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
            <el-dialog title='合同详情' :visible.sync="lookDialog" width='800px' center top='30vh' :close-on-click-modal='false'>
                <el-row :gutter="10">
                    <el-col :span="item.url.slice(item.url.lastIndexOf('.')+1,item.url.length)=='pdf'?24:6" v-for="item in imgList" :key='item.url'>
                        <div v-if="item.url.slice(item.url.lastIndexOf('.')+1,item.url.length)=='pdf'" class="fileClass">
                            <span > {{"入住合同"+item.url.slice(item.url.lastIndexOf("/")+1,item.url.length)}} </span>
                            <span>
                                <span style="margin-right:10px"
                                    @click="handleOpen(item.url)" >
                                    <i class="el-icon-view"></i>
                                </span>
                                <span @click="handleDownload(item.url)">
                                    <i class="el-icon-download"></i>
                                </span>
                            </span>
                        </div>
                        <img v-else :src="imgUrl+item.url" class="imgLook" @click="imgPreview(imgUrl+item.url)">
                    </el-col>
                </el-row>
                <el-image-viewer
                    v-if="imgDialog"
                    :on-close="imgClose"
                    :url-list="srcList" />
            </el-dialog>
        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList" v-on:downloadFile="downloadFile"></Add>
    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getMenuButton} from "@/utils/auth";
    import Add from "./Add";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
    export default {
        name: "Page",
        data() {
            return {
                showModalAdd:false,
                menuButtonList:null,
                disabledAdd:true,
                disabledLook:true,
                disabledCancellation:true,
                loading: false,
                elderlyName:"",
                uploadContractClassCode:"",
                uploadContractClassValue:[],
                dialogImageUrl:"",
                imgList:[],
                srcList:[],
                imgUrl:this.$imgUrl,
                lookDialog: false,
                imgDialog: false,
                dialogVisible: false,
                tableData: null,
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                th: 0,
                checkInfo:'',
                status:0,
                statusValue:[{label:'全部状态',value:-1},{label:'正常',value:0},{label:'作废',value:1}]
            }
        },

        created() {
            this.getList();
            this.getClassList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.th = val;
            },
        },
        components: {
            Add,ElImageViewer
        },
        methods: {
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="合同上传"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            cancellation(){
                this.$prompt('请输入作废原因', '作废', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'textarea'
                }).then(({ value }) => {
                    if(value){
                        this.$axios({
                            method: 'post',
                            url: this.$institutionUrl + "UploadContractItem/Cancellation",
                            data: {
                                timeStr: timeStr,
                                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                                staffCode: getStaffCode(),
                                uploadContractItemCode:this.checkInfo.uploadContractItemCode,
                                cancellation:value
                            }
                        }).then((response) => {
                            if (response.data.error == 0) {
                                this.$message.success('操作成功！')
                                this.getList()
                            } else if (response.data.error == 1) {
                                this.$message({type: 'info', message: response.data.message});
                            }
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }else{
                        this.$message.error('请输入作废原因！')
                    }
                    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '作废取消'
                    });       
                });
                
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace(/T/g,' ').slice(0,19):null
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init(this.uploadContractClassValue);
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            lookContract(){
                this.imgList=this.checkInfo.uploadContractItemImgList;
                for(var i in this.imgList){
                    this.srcList[i]=this.$imgUrl+this.imgList[i].url;
                }
                this.lookDialog = true;
            },
            imgClose() {this.imgDialog = false;},
            imgPreview(url){
                this.srcList=this.getPreviewList(url)
            },
            getPreviewList(url){
                this.imgDialog = true;
                var list=[]
                var list1=this.srcList;
                for(var i in list1){
                    if(list1[i]==url){
                        var str =list1.slice(i)
                        list=str.concat(list)
                        return list
                    }else{
                        list.push(list1[i])
                    }
                }
            },
            handleDownload(file){
                let fileName ="入住合同"+file.slice(file.lastIndexOf("/")+1,file.length);
                // this.downloadFile(this.$imgUrl+file, fileName)
                this.$axios.get(this.$institutionUrl + 'FileDownload/Download?url='+file,{
                    responseType: 'blob',
                }).then(    
                    (response) => {
                        this.downloadFile(response.data, fileName);
                    }
                )
            },
            handleOpen(file){
                window.open(this.$imgUrl+file)
            },
            downloadFile(content, filename) {
                var a = document.createElement('a')
                var blob = new Blob([content])
                var url = window.URL.createObjectURL(blob)
                a.href = url
                a.download = filename
                document.body.appendChild(a);
                a.click()
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a);
            },
            getList() {
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl + "UploadContractItem/Page",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        uploadContractClassCode:this.uploadContractClassCode,
                        pageIndex: this.currentPage,
                        pageSize: this.pageSize,
                        status:this.status
                    }
                }).then((response) => {
                    this.disabledLook=true
                    this.disabledCancellation=true
                    if (response.data.error == 0) {
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    } else if (response.data.error == 1) {
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getClassList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"UploadContractClass/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode()
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.uploadContractClassValue=response.data.data;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },
            rowClick(row){
                this.checkInfo=row
                this.disabledCancellation=true
                if(this.menuButtonList.indexOf("合同查看")!=-1){
                    this.disabledLook =false;
                }
                if(this.menuButtonList.indexOf("作废")!=-1&&row.status==0){
                    this.disabledCancellation=false
                }

            }

        }
    }
</script>

<style lang="scss" scoped>
    .contract /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
    .contract /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #F5F7FA;
        border-color: #E4E7ED;
        color: #000;
        cursor: not-allowed;
    }
    .contract .item{
        padding: 0px 20px;
    }
    .contract {
        .imgLook{
            height: 150px;
            width: 150px;
            border-radius: 5px;
            margin-bottom: 15px;
        }
        /deep/  .el-icon-circle-close:before {
            color: #fff;
        }
        .fileClass{
            display: flex;
            justify-content: space-between;
            padding: 0 10px;
            font-size: 17px;
        }
    }
    
</style>